import { render } from "./PR28-05222023.vue?vue&type=template&id=6917de31"
import script from "./PR28-05222023.vue?vue&type=script&lang=js"
export * from "./PR28-05222023.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__